import { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Link, withRouter } from 'react-router-dom';

import { InlineNotification, ModalNextContext } from '@jutro/components';
import { LoaderExt } from 'gw-components-platform-react';
import { IntlContext , useTranslator } from '@jutro/locale';
// import EditCertificatePage from './EditCertificatePage/EditCertificatePage';

import { messages as commonMessages } from '@xengage/gw-platform-translations';
import _ from 'lodash';
import {
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';


import moment from 'moment';
import EditCertificate from './EditCertificate/EditCertificate';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';
import usecpmiAnalytics from '../../hooks/usecpmiAnalytics';
import CertificateService from '../../../../common/capabilities/cpmi-capability-certificate/services/CertificateService';
import messages from './CertificatePage.messages';
import metadata from './CertificatePage.metadata.json5';
import styles from './CertificatePage.module.scss';

import { Button } from '@jutro/legacy/components';

import { Link as RouterLink } from '@jutro/router';

function CertificatePage(props) {
    const { history } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const [isLoading, setLoadingState] = useState(true);
    const [showBanner, setShowBanner] = useState(true);
    const [showRemoveBanner, setShowRemoveBanner] = useState(true);
    const [policysummary, setPolicysummary] = useState([]);
    const [termNumber, setTermNumber] = useState('');
    const [termPublicId, setTermPublicId] = useState('');
    const [policystatus, setPolicyStatus] = useState('');
    const [selectedPolicy, setSelectedPolicy] = useState('');
    const [certificateData, setCertificateData] = useState([]);
    const { authHeader } = useAuthentication();
    const ModalNext = useContext(ModalNextContext);
    const [holderCertData, setHolderCertData] = useState([]);
    const [selectedId, setSelectedId] = useState([]);
    const translator = useTranslator();
    const [certsToDelete, setCertsToDelete] = useState([]);
    const [deleteCert, setDeleteCert] = useState([]);
    const [policyPeriodData, setPolicyPeriodData] = useState([]);
    const [reportingData, setReportingData] = useState([]);
    const [filteredPayrollReport, setfilteredPayrollReport] = useState([]);
    const [SelectedPolicyperoid, setSelectedPolicyperoid] = useState(null);
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();

    const getPolicyPeroiddropdown = useCallback(
        (policyNumber) => {
            let policyperiod = policysummary
                .filter((policy) => {
                    return policy.policyNumber === policyNumber;
                })
                .map((policy) => {
                   
                    const startDate = moment(policy.effective).format(
                        'MM/DD/YYYY'
                    );
                    const endDate = moment(policy.expiration).format(
                        'MM/DD/YYYY'
                    );
                    return {
                        code: `${startDate} - ${endDate} - ${policy.displayStatus}`,
                        name: `${startDate} - ${endDate} - ${policy.displayStatus}`,
                        termNumber:policy.termNumber,
                        termPublicId:policy.termPublicId,
                        displayStatus:policy.displayStatus
                    };
                });
            policyperiod = policyperiod.filter(
                (value, index, self) =>
                    index ===
                    self.findIndex(
                        (t) => t.code === value.code && t.name === value.name
                    )
            ).sort((a, b)=> {
                const createSortKey = (p)=> { return `${p.code}`}
                return createSortKey(a) > createSortKey(b) ? -1 : 1
            });
            
            if(!_.isEmpty(policyperiod)){
                setTermNumber(policyperiod[0].termNumber);
                setTermPublicId(policyperiod[0].termPublicId);
                setPolicyStatus(policyperiod[0].displayStatus);
            }
            setPolicyPeriodData(policyperiod);
            setSelectedPolicyperoid(policyperiod[0]);
            return policyperiod;
        },
        [policysummary]
    );

    useEffect(() => {
        getPolicyPeroiddropdown(selectedPolicy);
    }, [getPolicyPeroiddropdown, policysummary, selectedPolicy]);

    useEffect(() => {
        trackPageView('Certificates of Insurance', '/certificate');
    }, []);

    useEffect(() => {
        trackGAPageView('/certificate/list', 'Certificates of Insurance');
    }, []);

    useEffect(() => {
        CertificateService.getAccountWCPolicyPeriodSummaries(authHeader).then(
            (result) => {
                const finlaResult = result.filter((policy) => policy.lineOfBusinessCode === "WC7Line")

                if(finlaResult.length===0){
               
                    setPolicysummary(finlaResult);
                    setLoadingState(false);
                    return ;
                   
                }

                finlaResult.map((i,index)=>{console.log(index,i.policyNumber)})
                finlaResult.sort((a, b)=> {
                    const createSortKey = (p)=> { return `${p.policyNumber}`}
                    return createSortKey(a) > createSortKey(b) ? -1 : 1
                })
                setSelectedPolicy(finlaResult[0].policyNumber);
                setPolicysummary(finlaResult);
            }
        );
    }, []);

    useEffect(() => {
        if (selectedPolicy.length !== 0 && termPublicId.length !== 0) {
           
            const data = [selectedPolicy, termPublicId];
            setLoadingState(true);
            CertificateService.listCertificates(data, authHeader)
                .then((result) => {
                    setCertificateData(result);
                   
                })
                .finally(() => {
                    setLoadingState(false);
                });
        }
    }, [authHeader, selectedPolicy, termPublicId]);

   

    const handlePolicytermselection = (value) => {
        setSelectedPolicyperoid(value);
        const selectedYear = value.split('-');
        selectedYear[0] = moment(selectedYear[0].trim()).format('MM/DD/YYYY');
        selectedYear[1] = moment(selectedYear[1].trim()).format('MM/DD/YYYY');
        const policyPeriodInfo=policysummary.filter((i)=>{
           
            return (moment(i.effective).format('MM/DD/YYYY')===selectedYear[0]) && (moment(i.expiration).format('MM/DD/YYYY')===selectedYear[1])
        })

        setTermPublicId(policyPeriodInfo[0].termPublicId)       
        setShowBanner(false) 
        setShowRemoveBanner(false)
    };

    const getPolicies = useCallback(() => {
        if(policysummary.length===0)
        {
            return []
        }
        let policies = [];
        policysummary.forEach((policy) => {
            if(policy.lineOfBusinessCode === "WC7Line"){
                const obj = {
                    code: policy.policyNumber,
                    name: `${policy.policyNumber} ${policy.states[0]}`,
                    termNumber: policy.termNumber,
                };
                policies.push(obj);
            }
        });

        policies = policies.filter(
            (value, index, self) =>
                index ===
                self.findIndex(
                    (t) => t.code === value.code && t.name === value.name
                )
        );
        return policies;
    }, [policysummary]);

    const handlePolicyChange = useCallback(
        (response) => {
            setSelectedPolicy(response);
            const termdata = policysummary.filter((i) => {
                return i.policyNumber === response;
            }).sort((a, b)=> {
                const createSortKey = (p)=> { return `${p.effective}  ${p.expiration}`}
                return createSortKey(a) > createSortKey(b) ? -1 : 1
            });;
            setPolicyStatus(termdata[0].displayStatus);
            setTermNumber(termdata[0].termNumber);
            setTermPublicId(termdata[0].termPublicId)
            setShowBanner(false)
            setShowRemoveBanner(false)
        },
        [policysummary, setShowBanner]
    );

    const createCertificate = useCallback(() => {
        const data = [selectedPolicy, termPublicId];
        setLoadingState(true);
        CertificateService.getCertPolicyPeriod(data, authHeader).then((res) => {
            setLoadingState(false);
            return history.push({
                pathname: `/certificate/create/${selectedPolicy}/${termPublicId}`,
                state: {
                    data: res,
                },
            });
        });
    }, [CertificateService, selectedPolicy, termPublicId, authHeader]);

    const removeCertificate = useCallback(() => {
        if(selectedId.length > 0)
        {
            const data = [certificateData[selectedId[0]].certificateId];
            const tempdelcerts = [];
            const certsDel = [];
            selectedId.map((val) => {
            // certsName.push(certificateData[val].holder.name)
                certsDel.push(certificateData[val].certificateId);
                tempdelcerts.push({
                    certId: certificateData[val].certificateId,
                    hname: certificateData[val].holder.name,
                });
            });

       
            setCertsToDelete(certsDel);

            ModalNext.showConfirm({
                title: messages.removeTitle,
                message: messages.removeMessage,
                status: 'info',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.yesModel,
                cancelButtonText: commonMessages.noModel,
            }).then((results) => {
                if (results === 'confirm') {
                    setLoadingState(true);
                    certsDel.forEach((certid)=>{
                        CertificateService.deleteCertificate([certid], authHeader)
                            .then((result) => {
                                setDeleteCert(tempdelcerts);
                                const tempList = [...certificateData];
                                const newList = tempList.filter(
                                    (prd) => certsDel.indexOf(prd.certificateId) === -1
                                );                  
                                setShowRemoveBanner(true)              
                                return setCertificateData(newList);
                            }).then(()=>{
                                setLoadingState(false);
                            })
                    })
                    
                       
                           
                       
                }
            }, _.noop);
        }
       
    }, [
        ModalNext,
        selectedId,
        CertificateService,
        authHeader,
        selectedId,
        certificateData,
    ]);

    const generateCertificatePdfZip = useCallback(() => {
        const data = [];
        certificateData.map((item) => {
            data.push(item.certificateId);
        });

        setLoadingState(true)
        CertificateService.generateCertificatePdfZip(data, authHeader).then(
            (result) => {
                const base64 = result.base64Contents;
                const byteString = atob(base64);

                // convert binary to array buff so we can construct a blob
                const arrayBuffer = new ArrayBuffer(byteString.length);
                const intArray = new Uint8Array(arrayBuffer);

                for (let i = 0; i < byteString.length; i += 1) {
                    intArray[i] = byteString.charCodeAt(i);
                }
                const file = new Blob([intArray], { type: result.fileType });
                const fileURL = URL.createObjectURL(file);
                const a = document.createElement('a');
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = `${result.fileName}`;
                a.click();
            }
        ).finally(() => {
            setLoadingState(false)
        })
    }, [CertificateService, authHeader, certificateData]);

    const generateCertificate = useCallback(() => {
        const data = [certificateData[selectedId[0]].certificateId];
        const certIdTogenPdf = [];

        selectedId.map((val) => {
            return certIdTogenPdf.push(certificateData[val].certificateId);
        });

        setLoadingState(true)
        CertificateService.generateCertificatePdf(data, authHeader).then(
            (result) => {
                const base64 = result.base64Contents;
                const byteString = atob(base64);

                // convert binary to array buff so we can construct a blob
                const arrayBuffer = new ArrayBuffer(byteString.length);
                const intArray = new Uint8Array(arrayBuffer);

                for (let i = 0; i < byteString.length; i += 1) {
                    intArray[i] = byteString.charCodeAt(i);
                }
                const file = new Blob([intArray], { type: result.fileType });
                const fileURL = URL.createObjectURL(file);
                const a = document.createElement('a');
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = `${result.fileName}.pdf`;
                a.click();
            }
        ).finally(() => {
            setLoadingState(false)
        })
    }, [certificateData, selectedId, CertificateService]);

    const getCell = (item, index, property) => {
        return item[property.id];
    };

    
    const getWaiver = (item, index, property) => {
       
        return  item.subWaiverConsumer;
    };

    const getHolderName = (item, index, property) => {
        const getHolderCertificate = () => {
            setLoadingState(true);
            CertificateService.getCertificate([item.certificateId], authHeader)
                .then((result) => {
                   
                    setHolderCertData(result);
                    return history.push({
                        pathname: '/certificate/edit/',
                        state: {
                            data: result,
                        },
                    });
                })
                .finally(() => {
                    setLoadingState(false);
                });
        };

        return (
            <button
                className={styles.link}

                // id={index}
                // onClick={e => getHolderCertificate(e, index, item)}
                onClick={getHolderCertificate}
            >
                {item.holder.name}
            </button>
        );
    };

    const handleCertificateSelection = useCallback(
        (item) => {
            setSelectedId(item);
        },
        [certificateData]
    );

    const displayNotification = () => {
        if (window.location.href.indexOf('list') > -1) return true;
        return false;
    };

    const displayDeleteNotification = () => {
       
        return deleteCert.map((item) => {
            return (
                <InlineNotification
                    id="inline-notification"
                    message={translator(messages.certsDeletedMessage, {
                        id: item.certId,
                        holdername: item.hname,
                    })}
                    className={styles.certsRemoveAddedInfoLabel}
                    type="info"
                    isDismissable
                />
            );
        });
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }

    const overrides = {
        PolicyFilterDropDown: {
            availableValues: getPolicies(policysummary),
            onValueChange: handlePolicyChange,
            value: selectedPolicy,
        },
        certificatesTable: {
            data: certificateData,
            visible:certificateData.length>0
        },
        certsAddedInfoLabelId: {
            visible: displayNotification() && showBanner,
        },
        certsDeletedInfoLabelId: {
            content: displayDeleteNotification(),
            visible: showRemoveBanner,
        },
        PolicytermFilter: {
            // availableValues: getPolicyPeroiddropdown(),
            availableValues: policyPeriodData,
            onValueChange: handlePolicytermselection,
            value: SelectedPolicyperoid,
        },
        buttonContainers:{
            visible:certificateData.length>0
        },
        noCertText:{
            visible:certificateData.length<=0 && policysummary.length>0
        },
        notification1:{
            visible:policysummary.length===0

        },
        pageTitleHorizontalLine:{
            visible:policysummary.length>0
        }
       
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
            createCertificate,
            getCell,
            getWaiver,
            removeCertificate,
            generateCertificatePdfZip,
            generateCertificate,
            getHolderName,
            handleCertificateSelection,
        },
    };

    // eslint-disable-next-line react/react-in-jsx-scope
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

export default withRouter(CertificatePage);